import { createContext } from 'react';

export type ISocketContext = {
  getSocket: Function;
  socket: any;
  socketStatus: string;
  connected: Function;
};

export const SocketContext = createContext<ISocketContext>({
  getSocket() {},
  socketStatus: '',
  socket: null,
  connected() {}
});
